// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:1080px){.master-list .column[data-v-48fbf96c]{width:200px}}.master-list .column[data-v-48fbf96c]:last-child{border-right:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
